import PropTypes from "prop-types";
import { Spin } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";
import PhotoIcon from "../../../assets/icons/photo.svg";
import { RowActionsMenu } from "../../../components/data-table";

function CategoryCard({ category, t, actionItems, onActionClick, menuDisabled, isActionLoading }) {
    const isActive = category?.status === "active";

    const statusDotClass = isActive ? "bg-[#22C55E]" : "bg-[#EF4444]";
    const statusTextClass = isActive ? "text-[#22C55E]" : "text-[#EF4444]";

    return (
        <article className="relative overflow-hidden rounded-2xl border border-[#E5E7EB]/80 bg-white shadow-sm ring-1 ring-black/[0.03]">
            {isActionLoading ? (
                <div
                    className="absolute inset-0 z-10 flex items-center justify-center rounded-2xl bg-white/70"
                    aria-busy="true"
                    aria-live="polite">
                    <Spin />
                </div>
            ) : null}
            <div
                className={`flex items-center gap-3 p-3.5${isActionLoading ? " pointer-events-none select-none opacity-50" : ""}`}
                aria-hidden={isActionLoading}>
                <div className="flex h-12 w-16 shrink-0 items-center justify-center overflow-hidden rounded-md bg-[#F2F4F7]">
                    {category?.image ? (
                        <img src={category.image} alt="" className="h-full w-full object-cover" />
                    ) : (
                        <img src={PhotoIcon} alt="" className="h-6 w-6 opacity-40" />
                    )}
                </div>

                <div className="flex min-w-0 flex-1 flex-col justify-center gap-1">
                    <p className="m-0 truncate text-base font-medium leading-tight text-[#2F2F46]">
                        {category?.categoryName || t("notAvailable")}
                    </p>
                    <div className="flex items-center gap-1.5">
                        <span
                            className={`h-1.5 w-1.5 shrink-0 rounded-full ${statusDotClass}`}
                            aria-hidden
                        />
                        <span className={`text-sm font-normal leading-none ${statusTextClass}`}>
                            {isActive ? t("rates.active") : t("rates.deactive")}
                        </span>
                    </div>
                </div>

                <RowActionsMenu
                    items={actionItems}
                    onClick={({ key }) => onActionClick(key, category)}
                    label={t("action")}
                    disabled={menuDisabled}
                    icon={<BsThreeDotsVertical className="text-xl" />}
                    className="!h-8 !w-8 shrink-0 !rounded-full text-[#667085]"
                />
            </div>
        </article>
    );
}

CategoryCard.propTypes = {
    category: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    actionItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    onActionClick: PropTypes.func.isRequired,
    menuDisabled: PropTypes.bool,
    isActionLoading: PropTypes.bool,
};

export default CategoryCard;
